// extracted by mini-css-extract-plugin
export default {"plus":"Plus_plus__9dcFh","plus--shape-minus":"Plus_plus--shape-minus__dyYkA","plus__vertical":"Plus_plus__vertical__Ro7LY"};